import { styled } from 'linaria/react';
import { ColorValueStrict } from 'fronton-react';

type SectionProps = {
  color?: ColorValueStrict;
}

export const Section = styled.section<SectionProps>`
  width: 100%;
  background-color: ${({ color }: SectionProps) => (color ? `var(--${color})` : 'var(--background-primary)')};

  @media (--only-largeDesktop) {
    margin-bottom: 80px;
  }

  @media (--from-tablet) and (--to-largeDesktop) {
    margin-bottom: 64px;
  }

  @media (--only-mobile) {
    margin-bottom: 40px;
  }
`;
